import { render, staticRenderFns } from "./BCLoadingAnimation.vue?vue&type=template&id=146b1fa5&scoped=true"
import script from "./BCLoadingAnimation.vue?vue&type=script&lang=ts"
export * from "./BCLoadingAnimation.vue?vue&type=script&lang=ts"
import style0 from "./BCLoadingAnimation.vue?vue&type=style&index=0&id=146b1fa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146b1fa5",
  null
  
)

export default component.exports